@if (selectOptions) {
    <div [formGroup]="selectOptions" class="variant-buttons">
        <div formArrayName="variants">
            @for (variant of productGroup.variantDropDown; track variant.typeId; let i = $index; let totalVariants = $count) {
                @if (!isCmsStyling) {
                    <div class="variant-label">
                        <span translate="cart.product.variant.label"></span>&nbsp;{{variant.type | lowercase}}
                    </div>
                }
                <div class="variant-options" [ngClass]="[(btnClass || ''), totalVariants > 1 ? 'has-multiple' : '']">
                    @if (variant.values?.length > 3) {
                        <select class="form-select variant-dropdown"
                                (change)="updateVariantByDropdown($event, variants.controls[i], variant)">
                            @for (option of variant.values; track option.valueId) {
                                <option [value]="option.valueId" [disabled]="option.isDisabled" [selected]="isVariantSelected(option.valueId, i)">
                                    {{option.value}}
                                </option>
                            }
                        </select>
                    } @else {
                        @for (option of variant.values; track option.valueId) {
                            <button type="button" class="variant-option-button"
                                    [ngClass]="isVariantSelected(option.valueId, i) ? 'selected': ''"
                                    (click)="updateVariant(option.valueId, variants.controls[i], variant)" [disabled]="option.isDisabled">
                                <span>{{option.value}}</span>
                            </button>
                        }
                    }
                </div>
            }
        </div>
    </div>
}
